import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="container-main py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <span className="text-2xl font-heading font-bold text-primary-400">
              黑料社区
            </span>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              独家爆料平台，海量真实内幕汇聚。加入黑料社区，与数百万用户共同见证真相。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="RSS">
                <i className="ri-rss-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              热门分类
            </h4>
            <ul className="space-y-2.5">
              {[
                { to: '/category/entertainment', label: '娱乐爆料' },
                { to: '/category/business', label: '商业内幕' },
                { to: '/category/workplace', label: '职场黑料' },
                { to: '/category/social', label: '社会热点' },
                { to: '/category/tech', label: '科技揭秘' },
              ].map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              关于我们
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  用户口碑
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  联系我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">
                  用户协议
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-mail-line mt-0.5 text-primary-400"></i>
                <span>tips@heiliaoshequ.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-phone-line mt-0.5 text-primary-400"></i>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line mt-0.5 text-primary-400"></i>
                <span>北京市朝阳区建国路88号</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="container-main py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 黑料社区 - 版权所有。本平台内容由用户实名投稿，不代表平台立场。
          </p>
          <p className="text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors duration-200">京ICP备2024XXXXXXXX号</a>
            <span className="mx-2">|</span>
            <a href="#" className="hover:text-background-300 transition-colors duration-200">京公网安备 1101050200XXXX号</a>
          </p>
        </div>
      </div>
    </footer>
  );
}